var map = {
	"./Ellipse 40.svg": 71923,
	"./Ellipse 41.svg": 66101,
	"./FitDance.svg": 96387,
	"./Group 42.svg": 49881,
	"./Reserva-light.svg": 32875,
	"./Reserva.svg": 79559,
	"./Vector.svg": 84726,
	"./archive.svg": 69040,
	"./business.svg": 41769,
	"./delete-image.svg": 753,
	"./login-light.svg": 27383,
	"./login.svg": 61134,
	"./mytasks.svg": 149,
	"./noprojects.svg": 84746,
	"./orgcreate.svg": 8720,
	"./undraw_connection_re_lcud 1.svg": 33806,
	"./undraw_real_time_analytics_re_yliv 1.svg": 97832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40968;